// Μετά από νέα δημοσίευση, ανοιχτές καρτέλες τρέχουν παλιό κώδικα και οι
// κλήσεις τους στον server αποτυγχάνουν. Ο server απαντά 409 με
// `x-mrpanda-stale`· εδώ κάνουμε μία αυτόματη ανανέωση της σελίδας.
const KEY = "mrpanda-stale-reload-at";

export function installStaleReload() {
  if (typeof window === "undefined") return;
  const w = window as unknown as { __mpStalePatched?: boolean };
  if (w.__mpStalePatched) return;
  w.__mpStalePatched = true;
  const orig = window.fetch.bind(window);
  window.fetch = async (...args: Parameters<typeof fetch>) => {
    const res = await orig(...args);
    if (res.status === 409 && res.headers.get("x-mrpanda-stale") === "1") {
      let last = 0;
      try {
        last = Number(sessionStorage.getItem(KEY) ?? 0);
      } catch {
        /* ignore */
      }
      if (Date.now() - last > 30_000) {
        try {
          sessionStorage.setItem(KEY, String(Date.now()));
        } catch {
          /* ignore */
        }
        window.location.reload();
      }
    }
    return res;
  };
}
